import MyModal from "./MyModal";
import { useRecoilValue } from "recoil";
import { areUploadedDocumentsLoadedAtom } from "../../LoadData/LoadData";
import Loc from "../../../Loc/Loc";

interface sendNewDocModalProps {
    modifyDoc: boolean;
    item?: any;
}

export default function SendNewDocModal(props: sendNewDocModalProps) {
    const areUploadedDocumentsLoaded = useRecoilValue(areUploadedDocumentsLoadedAtom);
    const textButton: string = props.modifyDoc ? Loc.trad().SendNewDocModalModify : Loc.trad().SendNewDocModalSend;
    const className: string = props.modifyDoc ? "btn btn-outline-secondary btn-sm" : "btn btn-success sendNewDocButton";
    const disabled: boolean = props.modifyDoc ? areUploadedDocumentsLoaded ? false : true : false;

    return (
        <MyModal
            className={className}
            style={{}}
            textButton={textButton}
            element={"sendNewDocModal"}
            disabled={disabled}
            modifyDoc={props.modifyDoc}
            item={props.item}
        ></MyModal>
    )
}